import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import type { FC } from "react";
import { translate } from "app/filters/i18nFilter";
import { SourceTypeMap } from "app/common/keyword-research/website-keywords/tableConsts";

export const WebsiteKeywordsTableTabSubtitle: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;
    const sourceType = widget._params.sourceType ?? SourceTypeMap.Total;
    const tableTab = translate(`dashboard.website.keywords.custom.subtitle.sourceType.${sourceType}.title`);
    return (
        <span
            title={tableTab}
            className="swWidget-dashboard-subTitle-tableTab"
        >
            {tableTab}
        </span>
    );
};
